module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_6000.2c007f94.png";